//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import handleErrorMixin from '@/mixins/handleErrorMixin'
import SkillTableMobile from './SkillTableMobile.vue'
import SkillTableDesktop from './SkillTableDesktop.vue'
import TRowDesktop from './TRowDesktop.vue'
import VALIDATION_TYPES from '~/constants/validation_type'
export default {
  components: {
    SkillTableMobile,
    SkillTableDesktop,
    TRowDesktop,
  },
  mixins: [handleErrorMixin],
  props: {
    skills: {
      type: Array,
      default: () => [],
    },
    showIndicatorPendings: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    async handleChange([skill, value]) {
      try {
        this.$emit('saving', true)
        const updatedSkill = await this.$repository.skillsValidations.update(
          skill.id,
          {
            supervisor_validate_skill: value,
            colaborator_has_skill: !!skill.user_has_skill,
            validation_type: this.getValidationType({
              supervisor: value,
              collaborator: !!skill.user_has_skill,
            }),
          }
        )

        this.$emit('update-skill', {
          ...skill,
          supervisor_validate_skill: updatedSkill.supervisor_validate_skill,
          user_has_skill: updatedSkill.colaborator_has_skill,
        })
      } catch (error) {
        this.handleError(
          error,
          'Ocurrió un error al actualizar la validación de la habilidad'
        )
      } finally {
        this.$emit('saving', false)
      }
    },
    getValidationType({ supervisor, collaborator }) {
      if (supervisor && collaborator) {
        return VALIDATION_TYPES.VALIDATED
      }
      if (supervisor && !collaborator) {
        return VALIDATION_TYPES.ADDED
      }
      if (!supervisor && collaborator) {
        return VALIDATION_TYPES.INVALIDATED
      }
      if (!supervisor && !collaborator) {
        return VALIDATION_TYPES.NOT_RECOGNIZED
      }
    },
  },
}
